<template>
  <font-awesome-icon :icon="iconType" :class="iconClass" />
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    technology: string;
    iconClass?: string;
  }>(),
  { iconClass: "" }
);

function getIconType(technology: string) {
  switch (technology) {
    case "SOLAR":
      return "solar-panel";
    case "WIND":
      return "wind-turbine";
    case "HYDRO":
      return "bridge-water";
    case "MARINE":
      return "water";
    case "BIOMASS":
      return "fire";
    case "NUCLEAR":
      return "radiation";
    default:
      return "bolt";
  }
}
const iconType = getIconType(props.technology);
</script>
